/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { Row, Col, Button, Form } from "react-bootstrap";
import InputForm from "../../components/inputs/InputForm";
import { Animation, toaster } from "rsuite";
import peticionBack from "../../libs/peticiones/peticionBack";
import AddresForm from "./components/form/AddresForm";
import DocumentForm from "./components/form/DocumentForm";
import DatesSwitchForm from "./components/form/DatesSwitchForm";
import { CollapseFilter } from "./components/CollapseFilter";
import { FormTesis } from "./FormTesis";
import Perspectives from "./components/form/Perspectives";
import { Distrito } from "../../types/compl-archivos/Distrito";
import { TypeDocument } from "../../enums/TypeDocument.enum";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown, faFilter } from "@fortawesome/free-solid-svg-icons";
import { Region } from "../../types/compl-archivos/Region";

export default function FormSearch({
    values,
    touched,
    errors,
    onChange,
    handleBlur,
    showForm,
    setShowForm,
    setFieldValue,
    typeSearch,
    setTypeSearch,
    reset,
    typeDocument,
    setTypeDocument,
    amnistia = false,
}: {
    values: any;
    touched: any;
    errors: any;
    onChange: any;
    handleBlur: any;
    showForm: any;
    setShowForm: any;
    setFieldValue: any;
    typeSearch: string;
    setTypeSearch: any;
    reset: any;
    typeDocument?: string;
    setTypeDocument?: Function;
    amnistia?: boolean;
}) {
    const [sistemas, setSistemas] = useState<Array<any>>([]);
    const [instancias, setInstancias] = useState<Array<any>>([]);
    const [delitos, setDelitos] = useState<any>([]);
    const [areas, setAreas] = useState<Array<any>>([]);
    const [regiones, setRegiones] = useState<Array<Region>>([]);
    const [distritos, setDistritos] = useState<Array<Distrito>>([]);
    const [tiposCarpeta, setTiposCarpeta] = useState<any[]>([]);
    const [materias, setMaterias] = useState<any[]>([]);

    const [showAddresForm, setShowAddresForm] = useState(false);
    const [showCaseForm, setShowCaseForm] = useState(false);
    const [showDatesForm, setShowDatesForm] = useState(false);
    const [showPerspectives, setShowPerspectives] = useState(false);
    const [showTesis, setShowTesis] = useState(true);

    useEffect(() => {
        getRegiones();
        getInstancias();
        getSistemas();
        getTypeFolder();
        getMaterias();
    }, []);

    useEffect(() => {
        if (values.region) {
            getDistritos(values.region);
        } else {
            setDistritos([]);
            setFieldValue("distrito", "");
        }
    }, [values.region]);

    useEffect(() => {
        if (values.subject) {
            getDelitos();
        }
    }, [values.subject]);

    useEffect(() => {
        if (values.distrito) {
            getAreas();
        } else {
            setAreas([]);
            setFieldValue("area", "");
        }
    }, [values.distrito]);
    async function getDistritos(reg: string) {
        const res = await peticionBack({}, `/distritos?region=${values.region}`, "GET", false, toaster);
        if (res && res.data) setDistritos(res.data);
    }

    async function getDelitos() {
        setDelitos([]);
        setFieldValue("delito", "");
        const res = await peticionBack({}, `/delitos?subject=${values.subject}`, "GET", false, toaster);
        if (res.data) {
            setDelitos(res.data);
        }
    }

    async function getTypeFolder() {
        const res = await peticionBack({}, "/tiposcarpeta", "GET", false, toaster);
        if (res) {
            if (amnistia) {
                setFieldValue("folderType", res.data.find((folder: any) => folder.name === "CARPETA DE AMNISTIA")._id);
            }
            setTiposCarpeta([...res.data]);
        }
    }
    async function getMaterias() {
        const res = await peticionBack({}, "/materias", "GET", false, toaster);
        if (res) setMaterias([...res.data]);
    }

    async function getAreas() {
        const res = await peticionBack({}, `/areas?district=${values.distrito}`, "GET", false, toaster);
        if (res) setAreas([...res.data]);
    }

    async function getInstancias() {
        const res = await peticionBack({}, "/instancias", "GET", false, toaster);
        if (res) setInstancias([...res.data]);
    }

    async function getSistemas() {
        const res = await peticionBack({}, "/sistemas", "GET", false, toaster);
        if (res) setSistemas([...res.data]);
    }
    async function getRegiones() {
        const res = await peticionBack({}, "/regiones", "GET", false, toaster);
        if (res) {
            setRegiones([...res.data]);
            setAreas([]);
        }
    }
    function clean() {
        reset();
        setShowAddresForm(false);
        setShowCaseForm(false);
        setShowPerspectives(false);
        setShowDatesForm(false);
    }

    function adminCollapse(collapse: "addres" | "case" | "perspectives" | "dates" | "jurisprudence", value: boolean) {
        switch (collapse) {
            case "addres":
                setShowAddresForm(value);
                setShowCaseForm(false);
                setShowPerspectives(false);
                setShowDatesForm(false);

                break;

            case "case":
                setShowAddresForm(false);
                setShowCaseForm(value);
                setShowPerspectives(false);
                setShowDatesForm(false);

                break;
            case "perspectives":
                setShowAddresForm(false);
                setShowCaseForm(false);
                setShowPerspectives(value);
                setShowDatesForm(false);

                break;
            case "dates":
                setShowAddresForm(false);
                setShowCaseForm(false);
                setShowPerspectives(false);
                setShowDatesForm(value);

                break;
            case "jurisprudence":
                setShowTesis(value);
                break;
            default:
                break;
        }
    }
    function onChangeDocumentType(value: string) {
        setShowForm(false);
        setTypeDocument?.(value);
        reset();
        setFieldValue("typeDocument", value);
    }
    const currentDoc = (typeDocument || values.typeDocument) as string;
    const isAcuerdos = currentDoc === TypeDocument.ACUERDOS;
    const isSentencias = currentDoc === TypeDocument.SENTENCIA;
    return (
        <div className={`searchLayout ${isSentencias ? "doc-sentencia" : ""}`}>
            {/* Fila 1: Tipo de documento (centrado, 1 columna) */}
            <div className="searchRow searchRowSingle">
                <div className="searchSectionLabel">Tipo de documento</div>
                <Form.Select
                    className="searchSelect"
                    value={values.typeDocument}
                    onChange={(e) => {
                        onChangeDocumentType(e.target.value);
                    }}
                >
                    <option value={TypeDocument.SENTENCIA}>Sentencias</option>
                    {/* <option value={TypeDocument.ACUERDOS}>Acuerdos</option>
          <option value={TypeDocument.TESIS}>Jurisprudencias</option> */}
                </Form.Select>
            </div>

            {/* Fila 2: Tipo de búsqueda (centrado, 2 columnas) */}
            <div className="searchRow searchRowTwoCols">
                <div className="searchSectionLabel">Tipo de búsqueda</div>
                <div className="searchTypeCards">
                    <div className={`searchTypeCard ${typeSearch === "match" ? "isActive" : ""}`} role="button" tabIndex={0} onClick={() => setTypeSearch("match")} onKeyDown={(e) => e.key === "Enter" && setTypeSearch("match")}>
                        <p className="searchTypeTitle">Frase exacta</p>
                        <p className="searchTypeDesc">Busca coincidencias literales (ideal para citas textuales).</p>
                    </div>

                    <div className={`searchTypeCard ${typeSearch === "terms" ? "isActive" : ""}`} role="button" tabIndex={0} onClick={() => setTypeSearch("terms")} onKeyDown={(e) => e.key === "Enter" && setTypeSearch("terms")}>
                        <p className="searchTypeTitle">Palabras clave</p>
                        <p className="searchTypeDesc">Busca términos relacionados (mejor para exploración).</p>
                    </div>
                </div>
            </div>

            {/* Fila 3: Texto a buscar (1 columna) */}
            <div className="searchRow searchRowSingle">
                <InputForm label="Texto a buscar" name="textToSearch" type="text" value={values.textToSearch} touched={touched.textToSearch} error={errors.textToSearch} onChangeMethod={onChange} onBlurMethod={handleBlur} />
            </div>

            {/* ACUERDOS: botones abajo del input */}
            {isAcuerdos && (
                <div className="searchRow searchRowActions">
                    <div className="searchActionsRow">
                        <Button className="btnSearchGhost" type="button" onClick={() => clean()}>
                            Limpiar
                        </Button>
                        <Button className="btnSearchPrimary" type="submit">
                            Buscar
                        </Button>
                    </div>
                </div>
            )}

            {/* SENTENCIAS / JURISPRUDENCIAS: collapse de filtros, luego botones */}
            {!isAcuerdos && (
                <>
                    <div className="searchAdvancedHeader" role="button" tabIndex={0} onClick={() => setShowForm(!showForm)} onKeyDown={(e) => e.key === "Enter" && setShowForm(!showForm)}>
                        <div className="searchAdvancedHeaderLeft">
                            <FontAwesomeIcon icon={faFilter} />
                            <span className="searchAdvancedHeaderTitle">Filtros avanzados</span>
                        </div>
                        <FontAwesomeIcon icon={faCaretDown} className={`searchAdvancedChevron ${showForm ? "isOpen" : ""}`} />
                    </div>

                    <div className="searchAdvancedWrap">
                        <Animation.Collapse in={showForm}>
                            {(props, ref) => (
                                <div ref={ref} {...props}>
                                    {currentDoc === TypeDocument.SENTENCIA ? (
                                        <div>
                                            <CollapseFilter
                                                showComponent={showAddresForm}
                                                setShowComponent={adminCollapse}
                                                title="Delimitación territorial"
                                                keyWord="addres"
                                                active={values.region || values.distrito || values.area || values.number || values.year ? true : false}
                                            >
                                                <AddresForm errors={errors} handleBlur={handleBlur} onChange={onChange} touched={touched} values={values} areas={areas} distritos={distritos} regiones={regiones} />
                                            </CollapseFilter>

                                            {!amnistia && (
                                                <CollapseFilter
                                                    showComponent={showCaseForm}
                                                    setShowComponent={adminCollapse}
                                                    title="Materia y juicio"
                                                    keyWord="case"
                                                    active={values.folderType || values.subject || values.system || values.delito ? true : false}
                                                >
                                                    <DocumentForm
                                                        errors={errors}
                                                        handleBlur={handleBlur}
                                                        onChange={onChange}
                                                        touched={touched}
                                                        values={values}
                                                        delitos={delitos}
                                                        materias={materias}
                                                        setFieldValue={setFieldValue}
                                                        showForm={showForm}
                                                        setShowForm={setShowForm}
                                                        tiposCarpeta={tiposCarpeta}
                                                        sistemas={sistemas}
                                                        instancias={instancias}
                                                        amnistia={amnistia}
                                                    />
                                                </CollapseFilter>
                                            )}

                                            <CollapseFilter showComponent={showDatesForm} setShowComponent={adminCollapse} title="Fechas" keyWord="dates" active={values.startDate || values.endDate ? true : false}>
                                                <DatesSwitchForm errors={errors} handleBlur={handleBlur} onChange={onChange} touched={touched} values={values} setFieldValue={setFieldValue} />
                                            </CollapseFilter>

                                            <CollapseFilter showComponent={showPerspectives} setShowComponent={adminCollapse} title="Perspectivas" keyWord="perspectives" active={values.searchWithPerspectives}>
                                                <Perspectives onChange={onChange} values={values} />
                                            </CollapseFilter>
                                        </div>
                                    ) : (
                                        <CollapseFilter
                                            showComponent={showTesis}
                                            setShowComponent={adminCollapse}
                                            title="Filtros para jurisprudencias"
                                            keyWord="jurisprudence"
                                            active={values.distrito || values.area || values.subject || values.year || values.jurisprudenceType ? true : false}
                                        >
                                            <FormTesis handleBlur={handleBlur} errors={errors} onChange={onChange} touched={touched} values={values} materias={materias} areas={areas} distritos={distritos} regiones={regiones} />
                                        </CollapseFilter>
                                    )}
                                </div>
                            )}
                        </Animation.Collapse>
                    </div>

                    <div className="searchRow searchRowActions">
                        <div className="searchActionsRow">
                            <Button className="btnSearchGhost" type="button" onClick={() => clean()}>
                                Limpiar
                            </Button>
                            <Button className="btnSearchPrimary" type="submit">
                                Buscar
                            </Button>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
}
